/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Button_Group_Nested_DropdownInputs */

const en_button_group_nested_dropdown = /** @type {(inputs: Button_Group_Nested_DropdownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Button group with nested dropdown`)
};

const fr_button_group_nested_dropdown = /** @type {(inputs: Button_Group_Nested_DropdownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Groupe de boutons avec menu déroulant`)
};

const de_button_group_nested_dropdown = /** @type {(inputs: Button_Group_Nested_DropdownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schaltflächengruppe mit verschachteltem Dropdown-Menü`)
};

const it_button_group_nested_dropdown = /** @type {(inputs: Button_Group_Nested_DropdownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gruppo di pulsanti con menu a discesa annidato`)
};

const ru_button_group_nested_dropdown = /** @type {(inputs: Button_Group_Nested_DropdownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Группа кнопок с вложенным выпадающим списком`)
};

const es_button_group_nested_dropdown = /** @type {(inputs: Button_Group_Nested_DropdownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupo de botones con menú desplegable anidado`)
};

const zh_cn2_button_group_nested_dropdown = /** @type {(inputs: Button_Group_Nested_DropdownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`带有嵌套下拉菜单的按钮组`)
};

const ja_button_group_nested_dropdown = /** @type {(inputs: Button_Group_Nested_DropdownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ネストされたドロップダウンを持つボタングループ`)
};

const hi_button_group_nested_dropdown = /** @type {(inputs: Button_Group_Nested_DropdownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नेस्टेड ड्रॉपडाउन के साथ बटन समूह`)
};

const pt_pt2_button_group_nested_dropdown = /** @type {(inputs: Button_Group_Nested_DropdownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupo de botões com lista suspensa aninhada`)
};

/**
* | output |
* | --- |
* | "Button group with nested dropdown" |
*
* @param {Button_Group_Nested_DropdownInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const button_group_nested_dropdown = /** @type {((inputs?: Button_Group_Nested_DropdownInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Button_Group_Nested_DropdownInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_button_group_nested_dropdown(inputs)
	if (locale === "de") return de_button_group_nested_dropdown(inputs)
	if (locale === "it") return it_button_group_nested_dropdown(inputs)
	if (locale === "ru") return ru_button_group_nested_dropdown(inputs)
	if (locale === "es") return es_button_group_nested_dropdown(inputs)
	if (locale === "zh-CN") return zh_cn2_button_group_nested_dropdown(inputs)
	if (locale === "ja") return ja_button_group_nested_dropdown(inputs)
	if (locale === "hi") return hi_button_group_nested_dropdown(inputs)
	if (locale === "pt-PT") return pt_pt2_button_group_nested_dropdown(inputs)
	return en_button_group_nested_dropdown(inputs)
});